import React from "react";

function Footer() {
  return (
    <div className="bg-black">
      Footer
      <a href="https://6v7dyy0q7cm.typeform.com/to/saRRoweX" target="_blank" rel="noreferrer">
        <div className="flex justify-center items-center">
          <svg
            width="408"
            height="352"
            viewBox="0 0 408 352"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M380.969 175.786C380.969 203.279 361.283 228.269 329.235 246.415C297.201 264.552 252.915 275.786 203.969 275.786C155.024 275.786 110.737 264.552 78.7044 246.415C46.6563 228.269 26.9695 203.279 26.9695 175.786C26.9695 148.293 46.6563 123.302 78.7044 105.157C110.737 87.0195 155.024 75.7856 203.969 75.7856C252.915 75.7856 297.201 87.0195 329.235 105.157C361.283 123.302 380.969 148.293 380.969 175.786Z"
              stroke="white"
            />
            <path
              d="M357.256 87.2856C371.003 111.095 366.449 142.581 347.767 174.32C329.094 206.043 296.357 237.916 253.97 262.388C211.582 286.861 167.611 299.275 130.801 299.585C93.974 299.894 64.4296 288.095 50.683 264.286C36.9365 240.476 41.4905 208.99 60.1722 177.251C78.8451 145.528 111.582 113.656 153.97 89.183C196.357 64.7104 240.328 52.2958 277.138 51.9864C313.965 51.6768 343.509 63.4758 357.256 87.2856Z"
              stroke="white"
            />
          </svg>
          <h1 className="text-[#1BEEFF] absolute text-[50px] font-kry hover:text-blue-200 cursor-pointer">
            Contact Me
          </h1>
        </div>
      </a>
    </div>
  );
}

export default Footer;
